import { render, staticRenderFns } from "./Promotions_Manage.vue?vue&type=template&id=98cadcd4&"
import script from "./Promotions_Manage.vue?vue&type=script&lang=js&"
export * from "./Promotions_Manage.vue?vue&type=script&lang=js&"
import style0 from "./Promotions_Manage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports